<template>
    <!-- 产品与服务 -->
    <main-page :title="title" :subtitle="subtitle" :description="description" :button-text="buttonText" :bg="bg" />
</template>
<script>
import MainPage from "./components/MainPage.vue";
export default {
    name: "product",
    components: {
        MainPage
    },
    data() {
        return {
            bg: "/img/pay/0-_BG-5.png",
        }
    },
    computed: {
        title() {
            return this.$t('product.title');
        },
        subtitle() {
            return this.$t('product.subtitle');
        },
        description() {
            return this.$t('product.description');
        },
        buttonText() {
            return this.$t('common.buttonText');
        },
    }
};
</script>
<style lang="scss" scoped></style>